'use client';

import {
  BookBookmark,
  BookOpen,
  Calculator,
  Cpu,
  GlobeHemisphereWest,
  PersonSimpleRun,
  Translate,
  MusicNotes,
  Palette,
} from '@phosphor-icons/react/dist/ssr';

/**
 * Statischer Subject-Glyph-Wrapper (Fach-Kacheln der Planseite, Fokus-Karten, Check-in).
 *
 * Switch-Pattern statt `const Icon = MAP[subject]; <Icon />`, damit die
 * `react-hooks/static-components`-Regel zufrieden ist (alle Icons werden
 * statisch referenziert, keine Component-Variable während Render).
 */
interface SubjectGlyphProps {
  subject: string;
  size?: number;
  strokeWidth?: number;
}

export function SubjectGlyph({ subject, size = 20 }: SubjectGlyphProps) {
  switch (subject) {
    case 'Mathematik':
      return <Calculator size={size} />;
    case 'Deutsch':
      return <BookOpen size={size} />;
    case 'NMG':
      return <GlobeHemisphereWest size={size} />;
    case 'Englisch':
      return <Translate size={size} />;
    case 'Französisch':
      return <Translate size={size} />;
    case 'Bildnerisches Gestalten':
      return <Palette size={size} />;
    case 'Musik':
      return <MusicNotes size={size} />;
    case 'Medien & Informatik':
      return <Cpu size={size} />;
    case 'Bewegung & Sport':
      return <PersonSimpleRun size={size} />;
    default:
      return <BookBookmark size={size} />;
  }
}
